import React, { useState } from 'react';
import Sidebar from '../components/AdminPanel/Sidebar';
import Usuarios from '../components/AdminPanel/Usuarios';
import Turnos from '../components/AdminPanel/Turnos'
import Tarjetas from '../components/AdminPanel/Tarjetas';
/* import jwt from "jsonwebtoken" */

const AdminPanel: React.FC = (): JSX.Element => {
  const [screen, setScreen] = useState<string>('Usuarios');
  
  const rol = localStorage.getItem('rol')
  
  

  const renderTabContent = (): JSX.Element | null => {
    switch (screen) {
      case 'Usuarios':
        return <Usuarios />;
      case 'Turnos':
        return <Turnos />;
      case 'Tarjetas':
        return <Tarjetas /> ;
      default:
        return null;
    }
  };

  return (
    <div className='flex flex-row'>
      {rol === 'admin' ?   <div className='flex flex-row'>
         <Sidebar setScreen={setScreen} />
         {renderTabContent()}
         </div> : 
     
         <p>No tienes autorizado el ingreso a esta seccion</p>
      }
   
    </div>
  );
};

export default AdminPanel;